"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_helper_1 = require("../helpers/cookie-helper");
var videoUrl = 'https://s3-eu-west-1.amazonaws.com/elbetvideo/vFootball/';
var vFootball = (function () {
    function vFootball(api, slip, ticketsHolder, credit, user) {
        this.underdogs = {};
        this.favorites = {};
        this.video1duration = 0;
        this.video2duration = 0;
        this.video3duration = 0;
        this.video4duration = 0;
        this.video5duration = 0;
        this.video6duration = 0;
        this.hostGoals = 0;
        this.awayGoals = 0;
        this.selectedMatch = 0;
        this.finishedMatches = [];
        this.matches = {};
        this.allMatches = {};
        this.teams = {
            'eArsenal': {
                'css': 'eArsenal',
                'abbreviation': 'ARS'
            },
            'eChelsea': {
                'css': 'eChelsea',
                'abbreviation': 'CHE'
            },
            'eLiverpool': {
                'css': 'eLiverpool',
                'abbreviation': 'LIV'
            },
            'eManchester C': {
                'css': 'eManchesterC',
                'abbreviation': 'MTC'
            },
            'eManchester U': {
                'css': 'eManchesterU',
                'abbreviation': 'MTU'
            },
            'eBordeaux': {
                'css': 'eBordeaux',
                'abbreviation': 'BRD'
            },
            'eLille': {
                'css': 'eLille',
                'abbreviation': 'LIL'
            },
            'eLyon': {
                'css': 'eLyon',
                'abbreviation': 'LYN'
            },
            'eMarseille': {
                'css': 'eMarseille',
                'abbreviation': 'MAR'
            },
            'ePSG': {
                'css': 'ePSG',
                'abbreviation': 'PSG'
            },
            'eBayern Munich': {
                'css': 'eBayernMunich',
                'abbreviation': 'BRM'
            },
            'eDortmund': {
                'css': 'eDortmund',
                'abbreviation': 'DOR'
            },
            'eHertha': {
                'css': 'eHertha',
                'abbreviation': 'HER'
            },
            'eLeverkusen': {
                'css': 'eLeverkusen',
                'abbreviation': 'LEV'
            },
            'eSchalke 04': {
                'css': 'eSchalke04',
                'abbreviation': 'S04'
            },
            'eInter': {
                'css': 'eInter',
                'abbreviation': 'INT'
            },
            'eJuventus': {
                'css': 'eJuventus',
                'abbreviation': 'JUV'
            },
            'eLazio': {
                'css': 'eLazio',
                'abbreviation': 'LAZ'
            },
            'eMilan': {
                'css': 'eMilan',
                'abbreviation': 'MIL'
            },
            'eRoma': {
                'css': 'eRoma',
                'abbreviation': 'ROM'
            },
            'eAtletico Bilbao': {
                'css': 'eAtleticoBilbao',
                'abbreviation': 'ATB'
            },
            'eAtletico Madrid': {
                'css': 'eAtleticoMadrid',
                'abbreviation': 'ATM'
            },
            'eBarcelona': {
                'css': 'eBarcelona',
                'abbreviation': 'FCB'
            },
            'eValencia': {
                'css': 'eValencia',
                'abbreviation': 'VAL'
            },
            'eReal Madrid': {
                'css': 'eRealMadrid',
                'abbreviation': 'RMD'
            },
        };
        this.api = api;
        this.slip = slip;
        this.ticketsHolder = ticketsHolder;
        this.credit = credit;
        this.user = user;
        this.translation = window['langArr'][window['language']];
    }
    vFootball.prototype.getTickets = function () {
        var self = this;
        window['ticketsTaken'] = true;
        self.api.send('/ticket/get', { 'SessionID': window['token'] }, function (response) {
            self.ticketsHolder.showTickets(response, self.allMatches);
        }, function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        });
    };
    vFootball.prototype.reload = function () {
        this.finishedMatches = [];
        this.matches = {};
        this.underdogs = {};
        this.favorites = {};
        this.video1duration = 0;
        this.video2duration = 0;
        this.video3duration = 0;
        this.video4duration = 0;
        this.video5duration = 0;
        this.video6duration = 0;
        this.hostGoals = 0;
        this.awayGoals = 0;
        $('#videoScore').text(this.hostGoals + '-' + this.awayGoals);
        clearTimeout(this.video1timer);
        clearTimeout(this.video2timer);
        clearTimeout(this.video3timer);
        clearTimeout(this.video4timer);
        clearTimeout(this.video5timer);
        clearTimeout(this.video6timer);
        clearTimeout(this.videoResultsTimer);
        clearInterval(this.progressInterval);
        clearTimeout(this.refreshTimer);
        this.loadMatches();
    };
    vFootball.prototype.clearTeamFlags = function () {
        for (var key in this.teams) {
            $('#home-flag').removeClass(this.teams[key]['css']);
            $('#away-flag').removeClass(this.teams[key]['css']);
        }
    };
    vFootball.prototype.loadMatches = function () {
        var self = this;
        this.api.send('/match/get', {}, function (response) {
            if (typeof response.status !== 'undefined' && typeof response.error !== 'undefined' && response.status == 0 && response.error == 'Unsupported browser') {
                alert('Unsupported browser');
                return;
            }
            if (typeof response.status !== 'undefined' && typeof response.error !== 'undefined' && response.status == 0 && response.error == 'Invalid ENV settings') {
                alert('Invalid ENV settings');
                return;
            }
            self.handleMatches(response);
            var updateCreditEvent = new CustomEvent("get_credit");
            window.dispatchEvent(updateCreditEvent);
        }, function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        });
    };
    vFootball.prototype.handleMatches = function (response) {
        if (response.screen == 'results') {
            this.showResults(response.results);
        }
        else if (response.screen == 'video') {
            this.showVideo(response);
        }
        this.scheduleRefresh(response.refresh);
        this.finishedMatches.push(response.matches[0]['ID']);
        this.finishedMatches.push(response.matches[1]['ID']);
        this.finishedMatches.push(response.matches[2]['ID']);
        var i = 0;
        for (var key in response.matches) {
            this.allMatches[i] = {};
            this.allMatches[i]['ID'] = response.matches[key]['ID'];
            this.allMatches[i]['status'] = response.matches[key]['status'];
            i++;
            if (response.matches[key]['status'] != 2) {
                this.matches[response.matches[key]['ID']] = {};
                this.matches[response.matches[key]['ID']]['ID'] = response.matches[key]['ID'];
                this.matches[response.matches[key]['ID']]['quotas'] = response.matches[key]['quotas'];
                this.matches[response.matches[key]['ID']]['status'] = response.matches[key]['status'];
                this.matches[response.matches[key]['ID']]['home'] = response.matches[key]['results']['home'];
                this.matches[response.matches[key]['ID']]['away'] = response.matches[key]['results']['away'];
                if (response.matches[key]['status'] == 0) {
                    var compare = [
                        response.matches[key]['quotas']['WinnerX'],
                        response.matches[key]['quotas']['Winner1'],
                        response.matches[key]['quotas']['Winner2']
                    ];
                    var index = compare.indexOf(Math.max.apply(Math, __spread(compare)));
                    switch (index) {
                        case 0:
                            this.underdogs[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                'X',
                                0,
                                response.matches[key]['quotas']['WinnerX'],
                                'WinnerX'
                            ];
                            break;
                        case 1:
                            this.underdogs[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                '1',
                                1,
                                response.matches[key]['quotas']['Winner1'],
                                'Winner1'
                            ];
                            break;
                        case 2:
                            this.underdogs[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                '2',
                                2,
                                response.matches[key]['quotas']['Winner2'],
                                'Winner2'
                            ];
                            break;
                        default:
                            console.error('Error selecting favorites/underdogs');
                    }
                    var index2 = compare.indexOf(Math.min.apply(Math, __spread(compare)));
                    switch (index2) {
                        case 0:
                            this.favorites[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                'X',
                                0,
                                response.matches[key]['quotas']['WinnerX'],
                                'WinnerX'
                            ];
                            break;
                        case 1:
                            this.favorites[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                '1',
                                1,
                                response.matches[key]['quotas']['Winner1'],
                                'Winner1'
                            ];
                            break;
                        case 2:
                            this.favorites[response.matches[key]['ID']] = [
                                this.matches[response.matches[key]['ID']],
                                '2',
                                2,
                                response.matches[key]['quotas']['Winner2'],
                                'Winner2'
                            ];
                            break;
                        default:
                            console.error('Error selecting favorites/underdogs');
                    }
                }
            }
        }
        this.updateSlip();
        this.updateMatches(response);
        this.updateQuotas();
        this.getTickets();
    };
    vFootball.prototype.updateMatches = function (response) {
        $('.bvgt-home').text(response.matches[3].results.home);
        $('.bvgt-away').text(response.matches[3].results.away);
        $('.betting-virtualf-games-title').show();
        for (var key in response.matches) {
            $('#match' + key).text(response.matches[key].localTime);
            if (parseInt(key) <= 2) {
                var FTHG = response.matches[key].results['FTHG'];
                var HTHG = response.matches[key].results['HTHG'];
                var FTAG = response.matches[key].results['FTAG'];
                var HTAG = response.matches[key].results['HTAG'];
                $('#match' + key).attr('title', response.matches[key].results.home + ' - ' + response.matches[key].results.away + ' ' + FTHG + ' : ' + FTAG + ' (' + HTHG + ':' + HTAG + ')');
            }
            else {
                $('#match' + key).attr('title', response.matches[key].results.home + ' - ' + response.matches[key].results.away + response.matches[key]['ID']);
            }
            $('#match' + key).parent().attr('data-matchid', response.matches[key].ID);
        }
        if (this.selectedMatch === 0 || this.matches[this.selectedMatch] === undefined || this.finishedMatches.indexOf(this.selectedMatch) !== -1) {
            this.selectedMatch = response.matches[3]['ID'];
        }
        $('.virtualf-timing').show();
    };
    vFootball.prototype.updateSlip = function () {
        this.slip.removeFinishedMatches(this.matches);
    };
    vFootball.prototype.showResults = function (results, showTimer) {
        if (showTimer === void 0) { showTimer = true; }
        if (showTimer === false) {
            $('.vdh-progress').hide();
            $('.vdh-time').hide();
        }
        else {
            $('.vdh-progress').show();
            $('.vdh-time').show();
        }
        this.clearTeamFlags();
        $('#home-flag').addClass(this.teams[results.home]['css']);
        $('#away-flag').addClass(this.teams[results.away]['css']);
        $('#matchResult').text(results.result);
        $('#matchWinner').text(this.translation[results.winner.toLowerCase()].toUpperCase());
        $('#matchTotalGoals').text(results.total_goals);
        $('#matchCorrectScore').text(results.correct_score);
        $('#matchHtFt').text(results.ht_ft);
        $('#homeGoals').text(results.home_goals);
        $('#awayGoals').text(results.away_goals);
        $('#homeTeam').text(results.home);
        $('#awayTeam').text(results.away);
        $('#results').show();
        $('#videos').hide();
    };
    vFootball.prototype.attemptPlay = function (response) {
        var self = this;
        if (this.video1duration != 0 &&
            this.video2duration != 0 &&
            this.video3duration != 0 &&
            this.video4duration != 0 &&
            this.video5duration != 0 &&
            this.video6duration != 0) {
            this.video1timer = setTimeout(function () {
                self.playVideo(1, response.video);
            }, 200);
            this.video2timer = setTimeout(function () {
                self.playVideo(2, response.video);
            }, self.video1duration);
            this.video3timer = setTimeout(function () {
                self.playVideo(3, response.video);
            }, self.video1duration + self.video2duration);
            this.video4timer = setTimeout(function () {
                self.playVideo(4, response.video);
            }, self.video1duration + self.video2duration + self.video3duration);
            this.video5timer = setTimeout(function () {
                self.playVideo(5, response.video);
            }, self.video1duration + self.video2duration + self.video3duration + self.video4duration);
            this.video6timer = setTimeout(function () {
                self.playVideo(6, response.video);
            }, self.video1duration + self.video2duration + self.video3duration + self.video4duration + self.video5duration);
            this.videoResultsTimer = setTimeout(function () {
                self.getTickets();
                self.showResults(response.results, false);
            }, self.video1duration + self.video2duration + self.video3duration + self.video4duration + self.video5duration);
        }
    };
    vFootball.prototype.getRandomNumber = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    vFootball.prototype.playVideo = function (videoNumber, video) {
        console.log('Playing video ' + videoNumber);
        var minutes = {
            1: [0, 15],
            2: [16, 30],
            3: [31, 45],
            4: [46, 60],
            5: [61, 75],
            6: [76, 90]
        };
        var randomMinute = this.getRandomNumber(minutes[videoNumber][0], minutes[videoNumber][1]);
        $('#videoMinute').text(randomMinute + "'");
        $('#matchVideo1')[0].pause();
        $('#matchVideo2')[0].pause();
        $('#matchVideo3')[0].pause();
        $('#matchVideo4')[0].pause();
        $('#matchVideo5')[0].pause();
        $('#matchVideo6')[0].pause();
        $('#matchVideo1').hide();
        $('#matchVideo2').hide();
        $('#matchVideo3').hide();
        $('#matchVideo4').hide();
        $('#matchVideo5').hide();
        $('#matchVideo6').hide();
        $('#matchVideo' + videoNumber).show();
        $('#matchVideo' + videoNumber)[0].play();
        if (videoNumber > 1 && videoNumber < 6) {
            console.log('Showing results for video:' + (videoNumber - 1));
            this.updateVideoResults(video[videoNumber - 2]);
        }
    };
    vFootball.prototype.updateVideoResults = function (videoName) {
        var params = videoName.split('_');
        var action = params[3].charAt(0);
        if (params[2] == 'H' && action == 'G') {
            this.hostGoals++;
            console.log('Host goal in video ' + videoName);
        }
        if (params[2] == 'A' && action == 'G') {
            this.awayGoals++;
            console.log('Away goal in video ' + videoName);
        }
        $('#videoScore').text(this.hostGoals + '-' + this.awayGoals);
    };
    vFootball.prototype.showVideo = function (response) {
        $('.vdh-progress').hide();
        $('.vdh-time').hide();
        $('#home-abbreviation').text(this.teams[response.results.home]['abbreviation']);
        $('#away-abbreviation').text(this.teams[response.results.away]['abbreviation']);
        var self = this;
        var video = response.video;
        var video1 = $('#matchVideo1')[0];
        video1.src = videoUrl + video[0] + '.mp4';
        video1.load();
        var video2 = $('#matchVideo2')[0];
        video2.src = videoUrl + video[1] + '.mp4';
        video2.load();
        var video3 = $('#matchVideo3')[0];
        video3.src = videoUrl + video[2] + '.mp4';
        video3.load();
        var video4 = $('#matchVideo4')[0];
        video4.src = videoUrl + video[3] + '.mp4';
        video4.load();
        var video5 = $('#matchVideo5')[0];
        video5.src = videoUrl + video[4] + '.mp4';
        video5.load();
        var video6 = $('#matchVideo6')[0];
        video6.src = videoUrl + video[5] + '.mp4';
        video6.load();
        video1.addEventListener('loadedmetadata', function playVideo1() {
            self.video1duration = Math.floor(video1.duration) * 1000;
            self.attemptPlay(response);
            video1.removeEventListener('loadedmetadata', playVideo1, false);
        });
        video2.addEventListener('loadedmetadata', function playVideo2() {
            self.video2duration = Math.floor(video2.duration) * 1000;
            self.attemptPlay(response);
            video2.removeEventListener('loadedmetadata', playVideo2, false);
        });
        video3.addEventListener('loadedmetadata', function playVideo3() {
            self.video3duration = Math.floor(video3.duration) * 1000;
            self.attemptPlay(response);
            video3.removeEventListener('loadedmetadata', playVideo3, false);
        });
        video4.addEventListener('loadedmetadata', function playVideo4() {
            self.video4duration = Math.floor(video4.duration) * 1000;
            self.attemptPlay(response);
            video4.removeEventListener('loadedmetadata', playVideo4, false);
        });
        video5.addEventListener('loadedmetadata', function playVideo5() {
            self.video5duration = Math.floor(video5.duration) * 1000;
            self.attemptPlay(response);
            video5.removeEventListener('loadedmetadata', playVideo5, false);
        });
        video6.addEventListener('loadedmetadata', function playVideo6() {
            self.video6duration = Math.floor(video6.duration) * 1000;
            self.attemptPlay(response);
            video6.removeEventListener('loadedmetadata', playVideo6, false);
        });
        $('#results').hide();
        $('#videos').show();
    };
    vFootball.prototype.scheduleRefresh = function (refresh) {
        var self = this;
        this.refreshTimer = setTimeout(function () {
            console.log("API call...");
            self.reload();
        }, parseInt(refresh + 3) * 1000);
        var initialWidth = parseInt(refresh) * 100 / 120;
        $('.vdh-progress-bar').css('width', initialWidth + '%');
        this.progressInterval = setInterval(function () {
            initialWidth = initialWidth - (1 * 100 / 120);
            $('.vdh-progress-bar').css('width', initialWidth + '%');
        }, 1000);
    };
    vFootball.prototype.buyTicketAdapter = function () {
        var _this = this;
        var json = this.slip.getTicketJSON();
        var bettingAmount = parseFloat($('#slip-btn').val());
        if (parseFloat(bettingAmount) < parseFloat($('#min-bet').data('value'))) {
            $('#modalErrorMessage').text(this.translation['minimum_stake_is'] + " " + $('#min-bet').data('value'));
            $('#buyTicketError').modal('show');
            return false;
        }
        if (parseFloat(bettingAmount) > parseFloat($('#max-bet').data('value'))) {
            $('#modalErrorMessage').text(this.translation['maximum_stake_is'] + " " + $('#max-bet').data('value'));
            $('#buyTicketError').modal('show');
            return false;
        }
        if (cookie_helper_1.default.get('uName') !== undefined && cookie_helper_1.default.get('uName') != '' && cookie_helper_1.default.get('uName') != null) {
            this.credit.getAsyncCredit(this.user).then(function (deposit) {
                if (parseFloat(bettingAmount.toString()) > parseFloat(deposit.toString())) {
                    $('#modalErrorMessage').text(_this.translation['you_dont_have_enough_deposit']);
                    $('#buyTicketError').modal('show');
                    return false;
                }
                if (json !== false) {
                    _this.api.send('/ticket/buy', json, function (response) {
                        if (response.Status == 1) {
                            _this.getTickets();
                            var updateCreditEvent = new CustomEvent("get_credit");
                            window.dispatchEvent(updateCreditEvent);
                            _this.slip.removeAllMatches();
                            $('#buyTicketModal').modal('show');
                            if ("TicketData" in response) {
                                if ("vFootballTicketData" in response.TicketData) {
                                    $('#boughtTicketId').html(" ID " + response.TicketData.vFootballTicketData[0].TicketID);
                                }
                            }
                            setTimeout(function () {
                                $('#buyTicketModal').modal('hide');
                                $('#boughtTicketId').html('');
                            }, 2000);
                            return true;
                        }
                        else {
                            $('#modalErrorMessage').text(_this.translation['error_purchasing_ticket']);
                            $('#buyTicketError').modal('show');
                            return false;
                        }
                    }, function (jqXHR, textStatus, errorThrown) {
                        console.log(jqXHR);
                        console.log(textStatus);
                        console.log(errorThrown);
                        return false;
                    });
                    return true;
                }
                else {
                    $('#modalErrorMessage').text(_this.translation['chose_some_bets']);
                    $('#buyTicketError').modal('show');
                    return false;
                }
            });
        }
        else {
            if (json !== false) {
                this.api.send('/ticket/buy', json, function (response) {
                    if (response.Status == 1) {
                        _this.getTickets();
                        var updateCreditEvent = new CustomEvent("get_credit");
                        window.dispatchEvent(updateCreditEvent);
                        _this.slip.removeAllMatches();
                        $('#buyTicketModal').modal('show');
                        if ("TicketData" in response) {
                            if ("vFootballTicketData" in response.TicketData) {
                                $('#boughtTicketId').html(" ID " + response.TicketData.vFootballTicketData[0].TicketID);
                            }
                        }
                        setTimeout(function () {
                            $('#buyTicketModal').modal('hide');
                            $('#boughtTicketId').html('');
                        }, 2000);
                        return true;
                    }
                    else {
                        $('#modalErrorMessage').text(_this.translation['error_purchasing_ticket']);
                        $('#buyTicketError').modal('show');
                        return false;
                    }
                }, function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR);
                    console.log(textStatus);
                    console.log(errorThrown);
                    return false;
                });
                return true;
            }
            else {
                $('#modalErrorMessage').text(this.translation['chose_some_bets']);
                $('#buyTicketError').modal('show');
                return false;
            }
            return true;
        }
        return true;
    };
    vFootball.prototype.getTokenPromise = function () {
        var tokenPromise = new Promise(function (resolve, reject) {
            window.addEventListener("message", function (event) {
                try {
                    if (JSON.parse(event.data).payload.action == 'login') {
                        window['customLoggedIn'] = true;
                        if (!JSON.parse(event.data).payload.token) {
                            reject(new Error('Empty Token Recieved'));
                        }
                        window['customToken'] = JSON.parse(event.data).payload.token;
                        resolve(window['customToken']);
                    }
                }
                catch (error) {
                    reject(error);
                }
            }, false);
            window['customToken'] ? resolve(window['customToken']) : '';
        });
        return tokenPromise;
    };
    vFootball.prototype.authenticate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!window['token']) return [3, 9];
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 7];
                        if (!(window['customLoggedIn'] && window['customToken'])) return [3, 1];
                        this.buyTicketAdapter();
                        return [3, 6];
                    case 1:
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this.getTokenPromise()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.slip.removeAllMatches();
                        return [2];
                    case 5:
                        this.buyTicketAdapter();
                        _a.label = 6;
                    case 6: return [3, 8];
                    case 7:
                        $('#modalErrorMessage').text(this.translation['please_login']);
                        $('#buyTicketError').modal('show');
                        return [2];
                    case 8: return [3, 17];
                    case 9:
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 16];
                        if (!(window['customLoggedIn'] && !window['customToken'])) return [3, 14];
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4, this.getTokenPromise()];
                    case 11:
                        _a.sent();
                        return [3, 13];
                    case 12:
                        error_2 = _a.sent();
                        this.slip.removeAllMatches();
                        return [2];
                    case 13:
                        this.buyTicketAdapter();
                        return [3, 15];
                    case 14:
                        this.buyTicketAdapter();
                        _a.label = 15;
                    case 15: return [3, 17];
                    case 16:
                        this.buyTicketAdapter();
                        _a.label = 17;
                    case 17: return [2];
                }
            });
        });
    };
    vFootball.prototype.isJsonString = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    vFootball.prototype.attachListeners = function () {
        var _this = this;
        var self = this;
        $('body').on('click', '.clickable-match', function () {
            var matchId = this.dataset.matchid;
            if (matchId !== undefined) {
                self.selectedMatch = parseInt(matchId);
            }
            self.updateMatchParticipants();
            self.updateQuotas();
        });
        $('body').on('click', '.bvg-btn', function () {
            self.markQuote(this);
        });
        $('body').on('click', '#clearAllBets', function () {
            self.slip.removeAllMatches();
        });
        $('body').on('click', '.slip-x', function () {
            var matchId = parseInt(this.dataset.matchid);
            self.slip.removeMatch(matchId);
            if (matchId === self.selectedMatch) {
                $('.bvg-btn').removeClass('active');
            }
        });
        $('body').on('click', '#buy-ticket-btn', function () {
            self.authenticate();
        });
        window.addEventListener("message", function (event) {
            try {
                if (!_this.isJsonString(event)) {
                    if (JSON.parse(event.data).payload.action == 'customLogout') {
                        window['customLoggedIn'] = true;
                        window['customToken'] = '';
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
        }, false);
        $('body').on('click', '#min-bet', function () {
            $('#slip-btn').val(parseFloat(this.dataset.value).toFixed(2));
            self.slip.update();
        });
        $('body').on('click', '#max-bet', function () {
            $('#slip-btn').val(parseFloat(this.dataset.value).toFixed(2));
            self.slip.update();
        });
        $('body').on('click', '#bet-100', function () {
            $('#slip-btn').val(parseFloat(this.dataset.value).toFixed(2));
            self.slip.update();
        });
        $('body').on('click', '#bet-200', function () {
            $('#slip-btn').val(parseFloat(this.dataset.value).toFixed(2));
            self.slip.update();
        });
        $('body').on('click', '#bet-400', function () {
            $('#slip-btn').val(parseFloat(this.dataset.value).toFixed(2));
            self.slip.update();
        });
        $('#slip-btn').on('input', function () {
            self.slip.update();
        });
        $('body').on('click', '#slip-amount-up', function () {
            var input = $('#slip-btn');
            if (input !== undefined) {
                var value = $(input).val();
                var max = $(input).attr('max');
                if (value !== undefined && max !== undefined) {
                    value = parseFloat(value.toString());
                    var step = $(input).attr('step');
                    if (step !== undefined) {
                        if (value + parseFloat(step) <= parseFloat(max)) {
                            $(input).val((value + parseFloat(step)).toFixed(2));
                        }
                        else {
                            $(input).val(parseFloat(max).toFixed(2));
                        }
                    }
                }
            }
            self.slip.update();
        });
        $('body').on('click', '#slip-amount-down', function () {
            var input = $('#slip-btn');
            if (input !== undefined) {
                var value = $(input).val();
                var min = $(input).attr('min');
                if (value !== undefined && min !== undefined) {
                    value = parseFloat(value.toString());
                    var step = $(input).attr('step');
                    if (step !== undefined) {
                        if (value - parseFloat(step) > parseFloat(min)) {
                            $(input).val((value - parseFloat(step)).toFixed(2));
                        }
                        else {
                            $(input).val(parseFloat(min).toFixed(2));
                        }
                    }
                }
            }
            self.slip.update();
        });
        $('body').on('click', '#underdogsButton', function () {
            self.slip.removeAllMatches();
            for (var key in self.underdogs) {
                var match = self.underdogs[key][0];
                var quotaTip = self.underdogs[key][1];
                var quotaCode = self.underdogs[key][2];
                var quotaValue = self.underdogs[key][3];
                var quotaId = self.underdogs[key][4];
                if (parseInt(key) == self.selectedMatch) {
                    $('#' + quotaId).parent().addClass('active');
                }
                self.slip.addMatch(match, quotaTip, quotaCode, quotaValue, quotaId);
            }
        });
        $('body').on('click', '#favoritesButton', function () {
            self.slip.removeAllMatches();
            for (var key in self.favorites) {
                var match = self.favorites[key][0];
                var quotaTip = self.favorites[key][1];
                var quotaCode = self.favorites[key][2];
                var quotaValue = self.favorites[key][3];
                var quotaId = self.favorites[key][4];
                if (parseInt(key) == self.selectedMatch) {
                    $('#' + quotaId).parent().addClass('active');
                }
                self.slip.addMatch(match, quotaTip, quotaCode, quotaValue, quotaId);
            }
        });
        this.slip.attachListeners();
    };
    vFootball.prototype.updateMatchParticipants = function () {
        $('.bvgt-home').text(this.matches[this.selectedMatch]['home']);
        $('.bvgt-away').text(this.matches[this.selectedMatch]['away']);
    };
    vFootball.prototype.updateQuotas = function () {
        var self = this;
        var match = this.matches[this.selectedMatch];
        $('.virtualf-betting-time-holder').removeClass('active');
        $('.virtualf-betting-time-holder').each(function (_index, elem) {
            if (elem.dataset.matchid == self.selectedMatch) {
                $(elem).addClass('active');
            }
        });
        $('.bvg-btn').removeClass('active');
        for (var key in match['quotas']) {
            if (this.slip.isPlayedQuota(this.selectedMatch, key)) {
                $('#' + key).parent().addClass('active');
            }
            $('#' + key).text(match['quotas'][key]);
            if (match['status'] != '0') {
                $('#' + key).parent().addClass('disabled');
            }
            else {
                $('#' + key).parent().removeClass('disabled');
            }
        }
    };
    vFootball.prototype.markQuote = function (element) {
        var quotaId = $(element).find('.bvg-btn-odds').attr('id');
        var quotaValue = $(element).find('.bvg-btn-odds').text();
        var quotaCode = element.dataset.code;
        var quotaTip = element.dataset.tip;
        $('.bvg-btn').removeClass('active');
        if (true === this.slip.isPlayedQuota(this.selectedMatch, quotaId)) {
            this.slip.removeMatch(this.selectedMatch);
        }
        else {
            $(element).addClass('active');
            this.slip.addMatch(this.matches[this.selectedMatch], quotaTip, quotaCode, quotaValue, quotaId);
        }
    };
    return vFootball;
}());
exports.default = vFootball;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/game/vfootball.ts
// module id = 1991
// module chunks = 6